import { IRExp } from '@/types/interfaces';

export default {
  expression: /([^0-9a-zA-Z-,./&()$:%+!? ]|\/\/|&&)/g,
  name: 'businessActivity',
} as IRExp;
